<template>
  <div class="my-account">
    <transition name="trs-fade-out-fast">
      <div class="alert alert--success" v-if="isUpdated">
        {{ $t('profile.updateInformation') }}
      </div>
    </transition>
    <h1 class="main-heading">{{ $t('updateAccount.updateTitle') }}</h1>
    <div class="my-account__inner">
      <form class="form" @submit.prevent="updateProfileHandler" @change="notChanged = true">
        <div class="form__row">

          <div class="form__group">
            <div class="form__control" :class="{ 'form__control--error': $v.profile.firstname.$error }">
              <label class="form__label" for="firstName">{{ $t('updateAccount.firstName') }}</label>
              <input class="form__input" @blur="onBlurHandler('firstname')" type="text" id="firstName"
                v-model="$v.profile.firstname.$model">
              <div class="form__error" v-if="!$v.profile.firstname.required">{{ $t('updateAccount.validation.firstName')
              }}</div>
              <div class="form__error" v-if="!$v.profile.firstname.minLength">{{
                $t('updateAccount.validation.firstNameMinLength') }}</div>
            </div>
            <div class="form__control" :class="{ 'form__control--error': $v.profile.lastname.$error }">
              <label class="form__label" for="lastName">{{ $t('updateAccount.lastName') }}</label>
              <input class="form__input" @blur="onBlurHandler('lastname')" type="text" id="lastName"
                v-model="$v.profile.lastname.$model">
              <div class="form__error" v-if="!$v.profile.lastname.required">{{ $t('updateAccount.validation.lastName') }}
              </div>
              <div class="form__error" v-if="!$v.profile.lastname.minLength">{{
                $t('updateAccount.validation.lastNameMinLength') }}</div>
            </div>
          </div>

          <div class="form__group">
            <div class="form__control"
              :class="{ 'form__control--error': $v.profile.email.$error || serverSideErrors.length }">
              <label class="form__label" for="email">{{ $t('updateAccount.email') }}</label>
              <input class="form__input" @blur="onBlurHandler('email')" type="email" id="email"
                v-model="$v.profile.email.$model">
              <div class="form__error" v-if="!$v.profile.email.email">{{ $t('updateAccount.validation.email') }}</div>
              <div class="form__error" v-if="!$v.profile.email.required">{{ $t('updateAccount.validation.emailIsRequired')
              }}</div>
              <div class="form__error" v-if="serverSideErrors.length">{{ $t('updateAccount.validation.emailIsExist') }}
              </div>
            </div>
            <!--
            <div class="form__control" :class="{ 'form__control--error': $v.profile.phone.$error }">
              <label class="form__label" for="tel">{{ $t('updateAccount.phone') }}</label>
              <input class="form__input" @blur="onBlurHandler('phone')" type="text" id="tel" v-model="$v.profile.phone.$model" @keypress="isSwissPhoneNumber($event)">
              <div class="form__error" v-if="!$v.profile.phone.required">{{ $t('updateAccount.validation.phone') }}</div>
              <div class="form__error" v-if="!$v.profile.phone.minLength">{{ $t('updateAccount.validation.phoneMinLength') }}</div>
              <div class="form__error" v-if="!$v.profile.phone.maxLength">{{ $t('updateAccount.validation.phoneMaxLength') }}</div>
            </div>
            -->
          </div>


          <div class="form__group">
            <div class="form__control" :class="{ 'form__control--error': $v.profile.street.$error }">
              <label class="form__label" for="street">{{ $t('updateAccount.street') }}</label>
              <input class="form__input" @blur="onBlurHandler('street')" type="text" id="street"
                v-model="$v.profile.street.$model">
              <div class="form__error" v-if="!$v.profile.street.required">{{ $t('updateAccount.validation.street') }}
              </div>
            </div>
            <div class="form__control" :class="{ 'form__control--error': $v.profile.postalcode.$error }">
              <label class="form__label" for="zipCode">{{ $t('updateAccount.zipCode') }}</label>
              <input class="form__input" @blur="onBlurHandler('postalcode')" type="text" id="zipCode"
                v-model="$v.profile.postalcode.$model">
              <div class="form__error" v-if="!$v.profile.postalcode.required">{{ $t('updateAccount.validation.postalcode')
              }}</div>
              <div class="form__error" v-if="!$v.profile.postalcode.minLength">{{
                $t('updateAccount.validation.postalcodeMinLength') }}</div>
              <div class="form__error" v-if="!$v.profile.postalcode.maxLength">{{
                $t('updateAccount.validation.postalcodeMaxLength') }}</div>
            </div>
          </div>

          <div class="form__group">
            <div class="form__control" :class="{ 'form__control--error': $v.profile.city.$error }">
              <label class="form__label" for="city">{{ $t('updateAccount.city') }}</label>
              <input class="form__input" @blur="onBlurHandler('city')" type="text" id="city"
                v-model="$v.profile.city.$model">
              <div class="form__error" v-if="!$v.profile.city.required">{{ $t('updateAccount.validation.city') }}</div>
            </div>
            <div class="form__control form__control-change-password">
              <router-link :to="{ name: 'ChangePassword' }">{{ $t('updateAccount.changePassword') }}</router-link>
            </div>
          </div>
        </div>
        <uploadImage @inputChange="handleImageUpload" />
        <div class="form__control">
          <button class="button button--primary" type="submit" :disabled="$v.profile.$invalid || !notChanged">{{
            $t('updateAccount.updateBtn') }}</button>
        </div>
        <div class="delete-action">
          <button class="button btn-delete" type="button" @click="deleteProfileHandler">{{
            $t('updateAccount.deleteAccount') }}</button>
        </div>
      </form>
      <div class="my-account__photo">
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'
import uploadImage from '@/components/AppUploadImage';
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default {
  name: "AppMyAccountForm",
  components: {
    uploadImage
  },
  validations: {
    profile: {
      firstname: {
        required,
        minLength: minLength(3)
      },
      lastname: {
        required,
        minLength: minLength(3)
      },
      phone: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(30)
      },
      email: {
        required,
        email
      },
      street: {
        required
      },
      postalcode: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(6)
      },
      city: {
        required
      }
    }
  },
  data() {
    return {
      isUpdated: false,
      notChanged: false,
      serverSideErrors: [],
      profile: { ...this.$store.getters['auth/getCurrentUser'] },
    }
  },
  computed: {
    updateUser() {
      const user = { ...this.profile };
      delete user['reservations']
      return user;
    }
  },
  methods: {
    ...mapActions('updateProfile', ['updateCurrentUser', 'deleteHandler']),
    ...mapActions('auth', ['logoutHandler']),
    isSwissPhoneNumber(e) {
      let t = e.target;
      if (t.hasAttribute('maxlength')) {
        t.value = t.value.slice(0, t.getAttribute('maxlength'));
      }
    },
    handleImageUpload(value) {
      this.profile.base64_image = value
    },
    onBlurHandler(fieldName) {
      this.$v.profile[fieldName].$touch();
    },
    updateProfileHandler() {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.$v.$reset();
        this.updateCurrentUser(this.updateUser)
          .then(({ success }) => {
            this.isUpdated = success
            document.body.scrollIntoView({ behavior: 'smooth' })
            setTimeout(() => this.isUpdated = false, 3000)
          })
        this.serverSideErrors = [];
      }
    },
    deleteProfileHandler() {
      Swal.fire({
        title: 'Sind Sie sicher?',
        text: this.$t('updateAccount.deleteConfirm'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, ich bin sicher!',
        cancelButtonText: 'Abbrechen'
      }).then((result) => {
        if (result.value) {
          this.deleteHandler(this.updateUser)
            .then(() => {
              this.logoutHandler();
            })
            .catch(e => {
              if (e.success === false) {
                if (e.message.includes("Konto kann nicht gelöscht werden")) {
                  Swal.fire('Achtung', e.message, 'error')
                }
              }
            });
        }
      })
    },
  }
}
</script>

